const Select = ({ options, placeholder, setState, state, height }) => {
  return (
    <div
      className={`${height} w-full md:w-[250px] relative h-[28px] 2xl:h-[35px] drop-shadow-2xl rounded-[100px] border-[#FFFFFF] border-[2px]`}
    >
      <div
        className={`w-full md:full   pointer-events-none absolute top-0 left-0 right-0 h-4 2xl:h-4 rounded-t-[100px] bg-gradient-to-b from-gray-400 to-transparent`}
      ></div>
      <select
        defaultValue={state}
        onChange={(e) => {
          setState ? setState(e.target.value) : null;
        }}
        className={`${height} text-[#4A4A4A]  text-[13px] md:text-[15px] w-full h-[28px] 2xl:h-[35px] rounded-2xl placeholder:text-start placeholder:text-[#4A4A4A] placeholder:text-[13px] md:placeholder:text-[15px] px-12`}
      >
        <option value="" disabled>
          {state ? state : placeholder}
        </option>
        {options.map((el, index) => {
          return (
            <option value={el[0]} key={index}>
              {el[1]}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Select;
